export default __webpack_public_path__ + "media/images/borderright3-60b3a8033f0d9df1707312ac3befd489.png";